
export const enum ReportViewMode {
  Measurement = 1,
  Findings,
  Graph,    
  History,
  Comment,
}; 

export const localStateKeys = {
    viewMode: ['viewMode'] as const,
    maxBlocks: ['maxBlocks'] as const,
} as const;

